import React, { forwardRef } from "react";

const FormInput = (
  { value, onChange, onBlur, name, error, placeholder, type },
  ref
) => {
  return (
    <div>
      <input
        ref={ref} // Add ref here
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        type={type || "text"}
        placeholder={placeholder || "Enter text"}
        className={`w-full px-4 bg-[#272727] py-4 text-white rounded-full focus:outline-none ${
          error
            ? "border border-red-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
            : "border-none focus:ring-2 focus:ring-blue-500"
        }`}
      />
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
};

export default forwardRef(FormInput); // Use forwardRef here
